import moment from "moment";
import React, { useMemo } from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CellProps, Column, useTable } from "react-table";

import { ApprovedUserData } from "../../pages/UserManagement";
type UserManagementTableProps = {
  users: ApprovedUserData[];
};

const UserManagementTable = ({ users }: UserManagementTableProps) => {
  const { t } = useTranslation();

  const columns = useMemo<Column<ApprovedUserData>[]>(() => {
    return [
      {
        Header: t<string>("userManagement.usersTableHeaderEmail"),
        accessor: "username" as const,
      },
      {
        Header: t<string>("userManagement.usersTableHeaderLastName"),
        accessor: "lastName" as const,
      },
      {
        Header: t<string>("userManagement.usersTableHeaderFirstName"),
        accessor: "firstName" as const,
      },
      {
        Cell: (props: CellProps<ApprovedUserData>): string => {
          return props.value ? moment(props.value).format("DD.MM.YYYY") : "";
        },
        Header: t<string>("userManagement.usersTableHeaderDateJoined"),
        accessor: "approvedAt" as const,
      },
    ];
  }, [t]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable<
    ApprovedUserData
  >({
    columns,
    data: users,
  });
  return (
    <Table className="bg-white" bordered hover {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr className="bg-white" {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()} data-cy="user-table">
        {rows.length === 0 && (
          <tr className="bg-white">
            <td colSpan={5}>{t("userManagement.usersTableNoResults")}</td>
          </tr>
        )}
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()} className="bg-white">
              {row.cells.map((cell) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    style={{
                      padding: ".25rem 1rem",
                      verticalAlign: "middle",
                      width: cell.column.getHeaderProps().key === "header_id" ? "100px" : "auto",
                    }}
                  >
                    {cell.render("Cell")}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

export default UserManagementTable;
